import WebsiteData = require("../util/websiteData");
import $ = require('jquery');

export default class WebcomponentUpsell {

    api: __Notification.Api;
    pollInterval: number;
    intervalTime = 500;

    static setStatusToSuccessSeen = (redirectAfterSuccess: boolean, webComponentId: string) => {
        $.ajax({
            url: "/rest/websites/" + WebsiteData.getId() + "/webcomponent-upsell",
            type: "post",
            processData: false,
            dataType: 'json',
            data: JSON.stringify({
                webComponentId: webComponentId,
                "status-code": "SUCCESS_SEEN"
            }),
            success: function() {
                if (redirectAfterSuccess) {
                    let redirectUrl = window.location.origin + window.location.pathname
                        + window.location.search + '#hm:cc-sa-item-' + webComponentId.toLowerCase();

                    window.location.href = redirectUrl;
                    window.location.reload();
                }
            },
            contentType: "application/vnd.oneandone.diy.website.webcomponent-upsell+json"
        });
    };

    static trackLink = (action: string, webComponentId: string) => {
        $(document).trigger(
            "diy-editor-generic-linkInteraction",
            {
                pageName: webComponentId + 'UpsellNotification',
                actionName: action
            }
        );
    };

    /** @deprecated to remove when the old notifications are no longer used */
    setApi(api: __Notification.Api) {
        this.api = api;
    };

    /** @deprecated to remove when the old notifications are no longer used */
    pollFunction = (webComponentId: string) => {
        $.ajax({
            url: "/rest/websites/" + WebsiteData.getId() + "/webcomponent-upsell/" + webComponentId,
            type: "get",
            accepts: "application/vnd.oneandone.diy.website.webcomponent-upsell+json",
            success: (response: any) => {
                switch (response['status-code']) {
                    case "SUCCESS":
                        this.stopPolling();
                        this.showNotification({"status-code": "SUCCESS", webComponentId: webComponentId});
                        break;
                    case "ERROR":
                    case "ERROR_SEEN":
                    case "SUCCESS_SEEN":
                        this.stopPolling();
                        break;
                    default:
                        break;
                }
            }
        });
    };

    /** @deprecated to remove when the old notifications are no longer used */
    startPolling(webComponentId: string) {
        this.pollInterval = setInterval(this.pollFunction, this.intervalTime, webComponentId);
    };

    /** @deprecated to remove when the old notifications are no longer used */
    showNotification(webComponent: {"status-code": string, webComponentId: string}) {
        this.stopPolling();

        let notificationObject = {
            type: 18,
            severity: 3,
            sticky: false,
            payload: {
                translationKey: webComponent.webComponentId + ".upsell"
            }
        };

        $("body").on('click', '#notification-upsell-successful-close', () => {
            WebcomponentUpsell.setStatusToSuccessSeen(false, webComponent.webComponentId);
            WebcomponentUpsell.trackLink('close', webComponent.webComponentId);

        }).on('click', '#notification-upsell-successful-yes', () => {
            WebcomponentUpsell.setStatusToSuccessSeen(true, webComponent.webComponentId);
            WebcomponentUpsell.trackLink('jumpToSiteAdmin', webComponent.webComponentId);
        });

        let apiRef = this.api;
        apiRef.ready(() => {
            apiRef.createNotification(notificationObject);
        });
    };

    /** @deprecated to remove when the old notifications are no longer used */
    stopPolling() {
        clearInterval(this.pollInterval);
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/app-upsell/webcomponentUpsell.ts
 **/